<script lang="ts" setup>
withDefaults(
  defineProps<{
    value: boolean
    closable?: boolean
    maskClosable?: boolean
    transparent?: boolean
    order?: number
    className?: string
  }>(),
  {
    order: 1,
    closable: true,
    maskClosable: false,
  },
)

const emit = defineEmits<{
  (event: 'input', value: boolean): void
}>()

function onClose() {
  emit('input', false)
}
</script>

<template>
  <portal to="root" :order="order">
    <transition name="fade">
      <div v-if="value" class="fixed inset-0 z-9999" :class="className">
        <div class="fixed inset-0 bg-n-modal-mask" @click="maskClosable && onClose()" />
        <div class="w-300px rounded-5px absolute top-1/2 left-1/2 -translate-1/2 z-100" :class="{ 'bg-n-modal-bg': !transparent }">
          <div v-if="closable" class="close-icon absolute right-0 -top-30px" :order="order" @click.passive="onClose">
            <i-assets-icon-close-modal class="w-7.5 h-7.5" />
          </div>
          <slot />
        </div>
      </div>
    </transition>
  </portal>
</template>
